module.exports = __webpack_public_path__ + "static/usloviya-obrabotki-pol'zovatel'skih-dannyh-na-sajtah-AO-Bank-131-af85c591e1d6856d5aa6b1275a84cfb8.pdf";